import React, { useState } from "react";

import Dso from "./Generic/Dso/Dso";
import Utilities from "./Generic/Utilities/Utilities";
import Meters from "./Generic/Meters/Meters";
import Reference from "./Generic/Reference/Reference";

import ElectricityUtilities from "./Electricity/Utilities/ElectricityUtilities";
import ElectricityMeters from "./Electricity/Meters/ElectricityMeters";
import GasMeters from "./Gas/Meters/GasMeters";
import WaterMeters from "./Water/Meters/WaterMeters";


import NavPills from "components/NavPills/NavPills.js";

import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import { makeStyles, withStyles } from "@mui/styles";
import Divider from "@mui/material/Divider";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import NatureIcon from "@mui/icons-material/Nature";
import OpacityIcon from "@mui/icons-material/Opacity";
import FireplaceIcon from "@mui/icons-material/Fireplace";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import WhatshotIcon from '@mui/icons-material/Whatshot';

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

export default function Energy() {
  const classes = useStyles();
  const [valueElectricity, setValueElectricity] = useState("0");
  const [valueGas, setValueGas] = useState("3");
  const [valueWater, setValueWater] = useState("6");
  const [valueHeat, setValueHeat] = useState("9");
  const [valueCold, setValueCold] = useState("12");
  const [valueFuel, setValueFuel] = useState("15");
  const [valueWood, setValueWood] = useState("18");
  const [valuePropane, setValuePropane] = useState("21");

  const handleElectricityTabChange = (event, newValue) => {
    setValueElectricity(newValue);
  };
  const handleGasTabChange = (event, newValue) => {
    setValueGas(newValue);
  };
  const handleWaterTabChange = (event, newValue) => {
    setValueWater(newValue);
  };
  const handleHeatTabChange = (event, newValue) => {
    setValueHeat(newValue);
  };
  const handleColdTabChange = (event, newValue) => {
    setValueCold(newValue);
  };
  const handleFuelTabChange = (event, newValue) => {
    setValueFuel(newValue);
  };
  const handleWoodTabChange = (event, newValue) => {
    setValueWood(newValue);
  };
  const handlePropaneTabChange = (event, newValue) => {
    setValuePropane(newValue);
  };


  return (
    <div className={classes.root}>
      <NavPills
        active={0}
        color="customGreen"
        horizontal={{
          tabsGrid: { xs: 12, sm: 12, md: 2, lg : 1},
          contentGrid: { xs: 12, sm: 12, md: 10, lg : 11 },
        }}
        tabs={[
          {
            tabButton: "Electricité",
            tabIcon: FlashOnIcon,
            tabContent: (
              <TabContext value={valueElectricity}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={0}
                      scrollButtons="auto"
                      value={valueElectricity}
                      onChange={handleElectricityTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab label="Distributeurs" value={"0"} />
                      <StyledTab
                        label="Contrats fournisseurs"
                        value={"1"}
                      />
                      <StyledTab label="Compteurs" value={"2"} />
                      <StyledTab label="Références Analyse" value={"30"} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={"0"} index={0}>
                    <Dso energy={"electricity"} parameters={"dso"} />
                  </TabPanel>
                  <TabPanel value={"1"} index={1}>
                    <ElectricityUtilities
                      energy={"electricity"}
                      parameters={"utilities"}
                    />
                  </TabPanel>
                  <TabPanel value={"2"} index={2}>
                    <ElectricityMeters
                      energy={"electricity"}
                      parameters={"meters"}
                    />
                  </TabPanel>
                  <TabPanel value={"30"} index={30}>
                    <Reference energy={"electricity"} parameters={"reference"}/>
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
          {
            tabButton: "Gaz",
            tabIcon: FireplaceIcon,
            tabContent: (
              <TabContext value={valueGas}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={3}
                      scrollButtons="auto"
                      value={valueGas}
                      onChange={handleGasTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab label="Distributeurs" value={"3"} />
                      <StyledTab
                        label="Contrats fournisseurs"
                        value={"4"}
                      />
                      <StyledTab label="Compteurs" value={"5"} />
                      <StyledTab label="Références Analyse" value={"31"} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={"3"} index={3}>
                    <Dso energy={"gas"} parameters={"dso"} />
                  </TabPanel>
                  <TabPanel value={"4"} index={4}>
                    <Utilities energy={"gas"} parameters={"utilities"} />
                  </TabPanel>
                  <TabPanel value={"5"} index={5}>
                    <GasMeters energy={"gas"} parameters={"meters"} />
                  </TabPanel>
                  <TabPanel value={"31"} index={31}>
                    <Reference energy={"gas"} parameters={"reference"}/>
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
          {
            tabButton: "Eau",
            tabIcon: OpacityIcon,
            tabContent: (
              <TabContext value={valueWater}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={6}
                      scrollButtons="auto"
                      value={valueWater}
                      onChange={handleWaterTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab
                        label="Distributeurs"
                        value={"6"}
                        index={6}
                      />
                      <StyledTab
                        label="Contrats fournisseurs"
                        value={"7"}
                      />
                      <StyledTab label="Compteurs" value={"8"} />
                      <StyledTab label="Références Analyse" value={"32"} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={"6"} index={6}>
                    <Dso energy={"water"} parameters={"dso"} />
                  </TabPanel>
                  <TabPanel value={"7"} index={7}>
                    <Utilities energy={"water"} parameters={"utilities"} />
                  </TabPanel>
                  <TabPanel value={"8"} index={8}>
                    <WaterMeters energy={"water"} parameters={"meters"} />
                  </TabPanel>
                  <TabPanel value={"32"} index={32}>
                    <Reference energy={"water"} parameters={"reference"}/>
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
          {
            tabButton: "Réseau de chaleur",
            tabIcon: WhatshotIcon,
            tabContent: (
              <TabContext value={valueHeat}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={9}
                      scrollButtons="auto"
                      value={valueHeat}
                      onChange={handleHeatTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab label="Distributeurs" value={"9"} />
                      <StyledTab
                        label="Contrats fournisseurs"
                        value={"10"}
                      />
                      <StyledTab label="Compteurs" value={"11"} />
                      <StyledTab label="Références Analyse" value={"33"} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={"9"} index={9}>
                    <Dso energy={"heat"} parameters={"dso"} />
                  </TabPanel>
                  <TabPanel value={"10"} index={10}>
                    <Utilities energy={"heat"} parameters={"utilities"} />
                  </TabPanel>
                  <TabPanel value={"11"} index={11}>
                    <Meters energy={"heat"} parameters={"meters"} />
                  </TabPanel>
                  <TabPanel value={"33"} index={33}>
                    <Reference energy={"heat"} parameters={"reference"}/>
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
          {
            tabButton: "Réseau frigorifique",
            tabIcon: AcUnitIcon,
            tabContent: (
              <TabContext value={valueCold}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={12}
                      scrollButtons="auto"
                      value={valueCold}
                      onChange={handleColdTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab label="Distributeurs" value={"12"} />
                      <StyledTab
                        label="Contrats fournisseurs"
                        value={"13"}
                      />
                      <StyledTab label="Compteurs" value={"14"} />
                      <StyledTab label="Références Analyse" value={"34"} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={"12"} index={12}>
                    <Dso energy={"cold"} parameters={"dso"} />
                  </TabPanel>
                  <TabPanel value={"13"} index={13}>
                    <Utilities energy={"cold"} parameters={"utilities"} />
                  </TabPanel>
                  <TabPanel value={"14"} index={14}>
                    <Meters energy={"cold"} parameters={"meters"} />
                  </TabPanel>
                  <TabPanel value={"34"} index={34}>
                    <Reference energy={"cold"} parameters={"reference"}/>
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
          {
            tabButton: "Fioul",
            tabIcon: LocalGasStationIcon,
            tabContent: (
              <TabContext value={valueFuel}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={15}
                      scrollButtons="auto"
                      value={valueFuel}
                      onChange={handleFuelTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab label="Distributeurs" value={"15"} />
                      <StyledTab
                        label="Contrats fournisseurs"
                        value={"16"}
                      />
                      <StyledTab label="Compteurs" value={"17"} />
                      <StyledTab label="Références Analyse" value={"35"} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={"15"} index={15}>
                    <Dso energy={"fuel"} parameters={"dso"} />
                  </TabPanel>
                  <TabPanel value={"16"} index={16}>
                    <Utilities energy={"fuel"} parameters={"utilities"} />
                  </TabPanel>
                  <TabPanel value={"17"} index={17}>
                    <Meters energy={"fuel"} parameters={"meters"} />
                  </TabPanel>
                  <TabPanel value={"35"} index={35}>
                    <Reference energy={"fuel"} parameters={"reference"}/>
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
          {
            tabButton: "Bois",
            tabIcon: NatureIcon,
            tabContent: (
              <TabContext value={valueWood}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={18}
                      scrollButtons="auto"
                      value={valueWood}
                      onChange={handleWoodTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab label="Liste distributeurs" value={"18"} />
                      <StyledTab
                        label="Liste contrats fournisseurs"
                        value={"19"}
                      />
                      <StyledTab label="Liste compteurs" value={"20"} />
                      <StyledTab label="Références Analyse" value={"36"} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={"18"} index={18}>
                    <Dso energy={"wood"} parameters={"dso"} />
                  </TabPanel>
                  <TabPanel value={"19"} index={19}>
                    <Utilities energy={"wood"} parameters={"utilities"} />
                  </TabPanel>
                  <TabPanel value={"20"} index={20}>
                    <Meters energy={"wood"} parameters={"meters"} />
                  </TabPanel>
                  <TabPanel value={"36"} index={36}>
                    <Reference energy={"wood"} parameters={"reference"}/>
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
          {
            tabButton: "Gaz propane",
            tabIcon: FireplaceIcon,
            tabContent: (
              <TabContext value={valuePropane}>
                <div className={classes.demo2}>
                  <AppBar
                    position="static"
                    className={classes.demo2}
                    style={{ boxShadow: "none", shadowColor: "red" }}
                  >
                    <StyledTabs
                      initialselectedindex={21}
                      scrollButtons="auto"
                      value={valuePropane}
                      onChange={handlePropaneTabChange}
                      aria-label="Horizontal tabs"
                      //className={classes.tabs}
                      TabIndicatorProps={{ style: { background: "#91C73C" } }}
                    >
                      <StyledTab label="Liste distributeurs" value={"21"} />
                      <StyledTab
                        label="Liste contrats fournisseurs"
                        value={"22"}
                      />
                      <StyledTab label="Liste compteurs" value={"23"} />
                      <StyledTab label="Références Analyse" value={"37"} />
                    </StyledTabs>
                  </AppBar>
                  <Divider variant="fullWidth" />
                  <TabPanel value={"21"} index={18}>
                    <Dso energy={"propane"} parameters={"dso"} />
                  </TabPanel>
                  <TabPanel value={"22"} index={19}>
                    <Utilities energy={"propane"} parameters={"utilities"} />
                  </TabPanel>
                  <TabPanel value={"23"} index={20}>
                    <Meters energy={"propane"} parameters={"meters"} />
                  </TabPanel>
                  <TabPanel value={"37"} index={37}>
                    <Reference energy={"propane"} parameters={"reference"}/>
                  </TabPanel>
                </div>
              </TabContext>
            ),
          },
        ]}
      />
    </div>
  );
}
